/**
 *
 * App.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 */

import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import HomePage from 'containers/HomePage/Loadable';
import LoginPage from 'containers/LoginPage/Loadable';
import ForgotPasswordPage from 'containers/ForgotPasswordPage/Loadable';
import SignUpPage from 'containers/SignUpPage/Loadable';
import ResetPasswordPage from 'containers/ResetPasswordPage/Loadable';
import NotFoundPage from 'containers/NotFoundPage/Loadable';
import LoadingPage from 'containers/LoadingPage/Loadable';
import SetupWizardPage from 'containers/SetupWizardPage/Loadable';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { useInjectSaga } from 'utils/injectSaga';
import withTitle from '../../hoc/withTitle';
import authSaga from '../../authSaga';

const Login = withTitle(LoginPage, 'Login · GA Connector');
const SignUp = withTitle(SignUpPage, 'Sign Up · GA Connector');
const ForgotPassword = withTitle(
  ForgotPasswordPage,
  'Reset Password · GA Connector',
);
const ResetPassword = withTitle(
  ResetPasswordPage,
  'Reset Password · GA Connector',
);

function RootRedirect() {
  if (localStorage.token) {
    return <Navigate to="/dashboard/account" replace />;
  }
  return <Navigate to="/login" replace />;
}

function App(props) {
  useInjectSaga({ key: 'authSaga', saga: authSaga });

  const { auth } = props;

  const [TwoCoWindowOpen, setTwoCoWindowOpen] = useState(false);

  useEffect(() => {
    const { TwoCoInlineCart } = window;

    if (TwoCoInlineCart) {
      TwoCoInlineCart.events.subscribe('cart:opened', function () {
        setTwoCoWindowOpen(true);
      });

      TwoCoInlineCart.events.subscribe('cart:closed', function () {
        setTwoCoWindowOpen(false);
      });
    }
  });

  return (
    <div>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/dashboard/*" element={<HomePage />} />
        <Route path="/setup/*" element={<SetupWizardPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/pipedrive-integration" element={<LoadingPage />} />
        <Route path="*" element={<NotFoundPage isLoggedOut />} />
      </Routes>

      <ToastContainer />

      {auth.userData && (
        <div className={`payment-notice ${TwoCoWindowOpen ? 'show' : ''}`}>
          <p>
            <span>Having issues with the checkout?</span>
            Try{' '}
            <a
              href={`https://gaconnector.com/buy/alternative-payment/?email=${auth.userData.email}`}
              target="_blank"
            >
              another payment method
            </a>{' '}
            or contact{' '}
            <a href="https://gaconnector.com/support/" target="_blank">
              support
            </a>
          </p>
        </div>
      )}
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {};
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(App);
